import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';

import { routerTransition } from '../app.router.animations';

@Component({
    selector: 'app-not-authorized',
    templateUrl: './not-authorized.component.html',
    styleUrls: ['./not-authorized.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.Default,
    animations: [routerTransition()],
    host: { '[@routerTransition]': '' }
})
export class NotAuthorizedComponent implements OnInit {
    constructor() {
        //
    }

    ngOnInit(): void {
        //
    }
}
